module.exports = __webpack_public_path__ + "media/cash.51dccb74.mp4";